import { routeName } from '@/constants/routeName';
import UserList from '@/views/UserManagement/UserList/index.vue';
import UserPage from '@/views/UserManagement/UserPage/index.vue';
import basicOptions from '@/router/basic-options';
export default [
    {
        path: 'user-management',
        name: routeName.USER_MANAGEMENT,
        component: UserList,
        meta: {
            ...basicOptions,
        },
    },
    {
        path: 'user-management/:pageType(create)',
        name: routeName.USER_MANAGEMENT_CREATE,
        component: UserPage,
        meta: {
            ...basicOptions,
        },
    },
    {
        path: 'user-management/:userId',
        redirect: {
            name: routeName.USER_MANAGEMENT_PAGE,
        },
        component: UserPage,
        meta: {
            ...basicOptions,
        },
    },
    {
        // userId는 로그인 정보인데 로그아웃하면 이 정보가 없어서 에러가 난다.
        // 따라서 userId 옵셔널로 해야 한다.
        // 20241227 윤태건
        path: 'user-management/:userId?/:pageType(detail|basic-info)',
        name: routeName.USER_MANAGEMENT_PAGE,
        component: UserPage,
        meta: {
            ...basicOptions,
        },
    },
];
